import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestCardComponent } from './request-card.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialMdcModule } from 'src/app/shared/material-mdc.module';



@NgModule({
  declarations: [RequestCardComponent],
  imports: [
    CommonModule,
    MaterialMdcModule,
    SharedModule
  ],
  exports: [RequestCardComponent]
})
export class RequestCardModule { }
